module.exports = __webpack_public_path__ + "media/images/phantom-icon-purple-c09037522c6184a72f109b6d2856554e.svg";